import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { toast } from "@/components/Toast";
import { X, MapPin, Building2 } from "lucide-react";
import { DeletedUserBadge } from "@/components/DeletedUserBadge";

/** Prompt AD (2026-09-21) — CAMBIO 4: detalle real detrás de "Vigiladores en
 * ronda". La tarjeta ahora cuenta PERSONAS distintas; este modal muestra
 * quiénes son, con su objetivo y su sede. No cambia ningún dato de ronda. */
export function PeopleInPatrolsModal({ onClose }) {
  const nav = useNavigate();
  const [rows, setRows] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/patrols?status=en_curso");
        const byPerson = {};
        for (const p of data) {
          if (!p.vigilador_id) continue;
          if (!byPerson[p.vigilador_id]) {
            byPerson[p.vigilador_id] = { ...p, patrol_count: 0 };
          }
          byPerson[p.vigilador_id].patrol_count += 1;
        }
        setRows(Object.values(byPerson));
      } catch (e) { setErr(formatApiError(e)); toast.error(formatApiError(e)); }
    })();
  }, []);

  const totalRondas = rows ? rows.reduce((a, r) => a + r.patrol_count, 0) : 0;

  return (
    <div className="modal-overlay" onClick={onClose} data-testid="people-in-patrols-modal-overlay">
      <div className="modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 560, maxHeight: "80vh", overflowY: "auto" }} data-testid="people-in-patrols-modal">
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 4 }}>
          <h3 style={{ margin: 0 }} data-testid="people-in-patrols-title">Vigiladores en ronda ({rows?.length ?? 0})</h3>
          <button onClick={onClose} className="btn-ghost" style={{ padding: 6 }} data-testid="people-in-patrols-close"><X size={16} /></button>
        </div>
        <p style={{ fontSize: 12, color: "var(--invict-text-muted)", margin: "0 0 14px" }}>
          Personas distintas con al menos una ronda en curso ahora mismo{rows ? ` · ${totalRondas} ronda(s) en curso` : ""}.
        </p>
        {err && <div className="card" style={{ borderColor: "#BF3437", color: "#8E2629" }}>{err}</div>}
        {!rows && !err && <div className="skel" style={{ height: 100 }} />}
        {rows && rows.length === 0 && <div style={{ fontSize: 13, color: "var(--invict-text-muted)" }} data-testid="people-in-patrols-empty">Nadie tiene una ronda en curso ahora.</div>}
        {rows && rows.length > 0 && (
          <div style={{ display: "flex", flexDirection: "column", gap: 6 }} data-testid="people-in-patrols-list">
            {rows.map((r) => (
              <div key={r.vigilador_id} data-testid={`people-in-patrols-row-${r.vigilador_id}`}
                style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 12px", border: "1px solid var(--invict-bone-3)", borderRadius: 4, background: "var(--invict-bone-2)" }}>
                <div>
                  <div style={{ fontWeight: 800, fontSize: 13, color: "#0A0A0A" }}>{r.vigilador_name}{r.vigilador_deleted && <DeletedUserBadge id={r.vigilador_id} />}</div>
                  <div style={{ fontSize: 11, color: "var(--invict-text-muted)", marginTop: 2 }}>
                    <Building2 size={11} style={{ marginRight: 4, verticalAlign: "-1px" }} />{r.client_name}
                    {r.site_name && <><MapPin size={11} style={{ marginLeft: 8, marginRight: 4, verticalAlign: "-1px" }} />{r.site_name}</>}
                  </div>
                </div>
                {r.patrol_count > 1 && <span className="badge gray" style={{ fontSize: 10 }}>{r.patrol_count} rondas</span>}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
